import exifr from "exifr";

const REDACTED_SECRET = "[REDACTED]";

/**
 * Hide token query values when a source URL is shown in the file-info overlay.
 */
export function redactSrcSecrets(src) {
  if (!src) {
    return src;
  }

  return String(src).replace(
    /([?&#](?:access_token|refresh_token)=)[^&#]*/gi,
    `$1${REDACTED_SECRET}`
  );
}

function formatExifValue(value) {
  if (value instanceof Date) {
    return value.toISOString();
  }

  if (Array.isArray(value)) {
    return value.map((entry) => formatExifValue(entry)).join(", ");
  }

  if (typeof value === "object" && value !== null) {
    return JSON.stringify(value);
  }

  return String(value);
}

export async function readImageExif(src) {
  try {
    const exif = await exifr.parse(src, {
      reviveValues: true,
      tiff: true,
      xmp: true,
      jfif: true,
    });

    return { exif: exif || null, error: null };
  } catch (error) {
    return {
      exif: null,
      error: error?.message || "Failed to read EXIF data.",
    };
  }
}

export function formatImageFileInfo({ src, naturalWidth, naturalHeight, exif, error }) {
  const lines = [`src: ${redactSrcSecrets(src) || "(unknown)"}`];

  if (naturalWidth && naturalHeight) {
    lines.push(`dimensions: ${naturalWidth}x${naturalHeight}`);
  }

  if (error) {
    lines.push(`error: ${error}`);
    return lines.join("\n");
  }

  if (!exif || Object.keys(exif).length === 0) {
    lines.push("exif: (none found)");
    return lines.join("\n");
  }

  lines.push("--- exif ---");

  Object.entries(exif)
    .sort(([leftKey], [rightKey]) => leftKey.localeCompare(rightKey))
    .forEach(([key, value]) => {
      lines.push(`${key}: ${formatExifValue(value)}`);
    });

  return lines.join("\n");
}
